<template>
<!-- 收付款人选择器 -->
  <Select   :style="{ width: width + 'px' }" :params="roleType" :placeholder="placeholder" clearable transfer :value="value" :disabled="disabled" filterable  @on-change="onChange">
    <Option v-for="item in payeeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
  </Select>
  <!-- 使用组件 -->
<!-- <payee-select  roleType="roleType" @onChange='onChange'></payee-select> -->
</template>

<script>
export default {
   model: {
    prop: 'value',
    event: 'onChange'
  },
  props: {
    width: {
      type: Number,
      default: 200
    },
    value:String,
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    roleType: String,
  },
  data() {
    return {
      payeeList: []
    }
  },
  mounted() {
      this.queryPayee()
  },
  methods: {
   async queryPayee() {
      let data = {
        url: 'CORE-MEMBER/messageService/baseInfoService/queryAllMembersByRoleAndCurrentUser',
        body:{roleId:this.roleType}
      }
      if(this.roleType){
         await this.invoke(data).then(res => {
        this.payeeList= res
      })

      }
   
    },
    onChange(val){
        this.$emit('onChange',val)
    }
  }

}
</script>

<style lang="scss" scoped>
</style>